<template>
  <div
    class="product-card-grid"
    :class="{ 'product-card-grid--with-border': !hideTitle }"
  >
    <p
      v-if="!hideTitle && title"
      class="text-other-label-bold"
      v-text="title"
    />

    <ul class="product-card-grid__grid">
      <li
        v-for="product of recommendedProducts"
        :key="product.id"
      >
        <product-card
          hide-tagline
          :product="product"
        />
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * Vue: Product card grid (product-card-grid)
 * -----------------------------------------------------------------------------
 * Displays product cards in a 2x2 grid.
 *
 * @param {Boolean} [hideTitle] - If title should be hidden.
 * @param {Number} productId - Product ID.
 * @param {String} recommendationsId - Tagalys recommendations ID.
 *
 */

import { onTagalysReady } from '~/apis/tagalys'
import { formatProduct } from '~/format/format-tagalys'

import ProductCard from '~async/product-card/product-card'

export default {
  name: 'ProductCardGrid',

  components: {
    ProductCard,
  },

  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      required: true,
      default: 0,
    },
    recommendationsId: {
      type: String,
      required: true,
      default: '',
    },
  },

  data() {
    return {
      limit: 4,
      recommendedProducts: [],
      title: '',
    }
  },

  mounted() {
    this.setRecommendedProducts()
  },

  methods: {

    /**
     * Call Tagalys ready file to run config and callback function.
     */
    initialiseTagalys() {
      if (!this.recommendationsId) {
        return
      }

      onTagalysReady(this.tagalysCallback)
    },

    /**
     * Set recommended products to liquid carousel data, or initialise Tagalys
     * if an ID is present.
     */
    setRecommendedProducts() {
      if (!this.recommendationsId) {
        return
      }

      this.initialiseTagalys()
    },

    /**
     * Tagalys functions to run after setup has completed.
     */
    tagalysCallback() {
      this.callRecommendations()
    },

    /**
     * Query Tagalys for products based on ID in Shopify section settings.
     * - If there are responses, re-assign `recommendedProducts` for the
     *   product card carousel component.
     */
    async callRecommendations() {
      await this.$nextTick().then(() => {
        window.Tagalys.APIConnector.Recommendations.call({
          params: {
            productId: this.productId,
            recommendationId: this.recommendationsId,
            limit: 4,
          },
          onSuccess: (response) => {
            if (response.products.length <= 0) {
              return
            }

            this.recommendedProducts = response.products.map((tagalysProduct) => {
              return formatProduct(tagalysProduct)
            })

            this.title = response.name
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import './product-card-grid';
</style>
